module.exports = __webpack_public_path__ + "img/logo-b-w.721b7cb9.svg";